<template>
  <div class="gameAreaDiv" :style="{
    borderTopLeftRadius: HNewGameUIConfig.newGameUIType === 0?'20px':'0',
    borderTopRightRadius: HNewGameUIConfig.newGameUIType === 0?'20px':'0',
    borderTop: HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 4?'':'1px solid #ccc',
  }">
    <div style="display: flex; width: 100%;">
      <div style="width: 76px;">
        <div ref="scrollContainerRef" class="leftCategory" :style="{
        height:bottomContainerHeight+'px',
    }">
          <div v-for="(item, index) in leftIconInfo" :key="index">
            <div v-if="HNewGameUIConfig.newGameUIType===4" @click="changeSwiperPage(index)"
                 :style="{
                    width:'76px',
                    height:'30px',
                    marginBottom:'6px',
                    color:swiperIndex === index?'white':'#888',
                    fontSize:'16px',
                    paddingLeft:'6px',
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center',
                    backgroundImage:swiperIndex === index?`url(${iconJmttTitleBg})`:'',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '100% 100%',
                    backgroundPosition: 'left',
                 }"
               >
              {{item["name"]}}
            </div>
            <HCacheImage v-if="HNewGameUIConfig.newGameUIType!==4" @click="changeSwiperPage(index)" :src="swiperIndex === index?item.icon_press:item.icon"
                         width="60px" :height="HNewGameUIConfig.newGameUIType === 0 ?'60px':'66px'" style="margin-bottom: 6px;"/>
          </div>
        </div>
      </div>
      <div style="width: calc(100% - 76px);">
        <HSwiperLR ref="swiperLrRef" :data="data" :onSwipeChange="onSwipeChange" :height="bottomContainerHeight"
                   style="margin-top: 11px;">
          <template #default="{ items, pageIndex }">
            <div class="rightAreaParent">
              <div class="allRowParent" v-for="eachTemplate in items['TemplateList']" :key="eachTemplate['Id']">
                <GameAreaParserTemplate :favoriteCallback="getLobbyData" :eachTemplate="eachTemplate"/>
              </div>
            </div>
          </template>
        </HSwiperLR>
      </div>
    </div>
  </div>
</template>


<script setup>
  import HSwiperLR from "@/components/utils/HSwiperLR.vue";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import HCacheImage from "@/components/utils/HCacheImage.vue";
  import GameAreaParserTemplate from "@/components/pages/home/GameAreaParserTemplate.vue";
  import {ref} from "vue";
  import {emitter, hcf} from "@/components/utils/HComFunctions.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  const iconJmttTitleBg = hcf.getNewGameUIIcon("flag_choose.png");

  defineProps(["bottomContainerHeight"]);
  let useHttp = useHHttp();

  let swiperIndex = ref(0);
  //居中
  const scrollContainerRef = ref();

  function scrollToCenter(index, isAnimate = true) {
    let targetYValue = 60 * index - 90;
    if (isAnimate) {
      scrollContainerRef.value.scrollTo({
        top: targetYValue,
        behavior: 'smooth'
      });
    } else {
      scrollContainerRef.value.scrollTop = targetYValue;
    }
  }

  function onSwipeChange(index) {
    swiperIndex.value = index;
    // 滚动该图标到容器中间
    scrollToCenter(index);
  }

  function changeSwiperPage(index) {
    swiperLrRef.value.changeSwiperPage(index);
    // 滚动该图标到容器中间
    scrollToCenter(index);
  }

  let data = ref([]);
  let leftIconInfo = ref([]);
  let swiperLrRef = ref();

  function getLobbyData() {
    useHttp.request("/qp/game/lobby", (respData) => {
      leftIconInfo.value = [];
      data.value = respData.Data;
      for (let each of data.value) {
        leftIconInfo.value.push({
          "icon": each["Icon2"],
          'icon_press': each["Icon1"],
          'name':each['Name'],
        });
      }
    }, {isShowLoading: false})
  }

  onActivated(() => {
    scrollToCenter(swiperIndex.value, false);
  });

  onMounted(() => {
    emitter.on("REFRESH_HOME_LOBBY_LIST", () => {
      getLobbyData();
    });
    getLobbyData();
  });

</script>


<style scoped>
  .leftCategory {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
  }

  .leftCategory::-webkit-scrollbar {
    display: none;
  }

  .gameAreaDiv {
    display: flex;
    flex-direction: row;
    background-color: white;
    border-bottom: none;
    border-left: none;
    border-right: none;
  }

  .rightAreaParent {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }

  .allRowParent {
    display: flex;
    flex-direction: row;
  }
</style>
